import isEmpty from 'lodash/isEmpty';

export default {
    computed: {
        sortingValues () {
            return this.$store.getters['search/getFilter'].sorting;
        },
        prevFilter () {
            return this.$store.getters['search/getPrevFilter'];
        },
        isFilterEmpty () {
            return this.checkIfFilterEmpty(this.filter);
        },
        isCurrentFilterEmpty () {
            return this.checkIfFilterEmpty(this.prevFilter);
        }
    },
    methods: {
        checkIfFilterEmpty (filters) {
            const filter = {};
            for (const [key, value] of Object.entries(filters)) {
                if (key === 'sorting') continue;
                if (value && value.length !== 0) {
                    filter[key] = value;
                }
            }
            return isEmpty(filter);
        },
        getFiltersWithValue () {
            const filters = {};
            for (const [key, value] of Object.entries(this.filter)) {
                if (key === 'sorting') {
                    const sortingParams = {};
                    for (const [sortingKey, sortingValue] of Object.entries(value)) {
                        if (sortingValue) {
                            sortingParams[sortingKey] = sortingValue;
                        }
                    }
                    if (Object.keys(sortingParams).length !== 0) {
                        filters.order = sortingParams;
                    }
                } else if (value && value.length !== 0) {
                    filters[key] = value;
                }
            }
            this.$store.commit('search/setPrevFilter', filters);
            return filters;
        },
        sorting (header) {
            this.sortByValue(header);
        },
        sortByValue (header, sortable) {
            if (header.sort && header.value != null) {
                let value = this.sortingValues[header.value];
                value = value === 'asc' ? 'desc' : 'asc';
                header.icon = value === 'asc' ? 'SortIcon' : 'SortIconRevert';
                this.$store.commit('search/setSorting', {
                    key: header.value,
                    value
                });
                this.$emit('sorting');
            }
        }
    }
};
